import React from "react";

/**
 * BELO wordmark — the exact asset from belorentals.com (`belo-og.png`
 * cropped to the wordmark region + alpha-transparency mask).
 *
 * Public files:
 *   • /belo-logo.png       — black wordmark, transparent bg (370×100)
 *   • /belo-logo-white.png — white wordmark, transparent bg (same mask)
 *   • /favicon.png         — the belorentals "B" mark on the dark badge
 *
 * The wordmark itself is stencil / architectural: three-bar E, straight-
 * edged double-bar B with rounded caps, straight L, near-circular O.
 * Because it's a raster (with anti-aliased edges) we ship the actual
 * artwork rather than an SVG approximation.
 *
 * Props:
 *   • `size` / `height` — height in px (default 60). Width scales with
 *     the 370:100 aspect (~3.7:1).
 *   • `color` — supports the two variants the codebase actually uses:
 *     dark for light backgrounds (default) and `"#ffffff"` for dark
 *     backgrounds. Anything else falls back to dark.
 *   • `className` — passed through to the <img>.
 */
export const BeloLogo = ({
  size,
  height,
  color = "#000000",
  className = "",
  ...rest
}) => {
  const px = size ?? height ?? 60;
  const isLight = typeof color === "string" && color.toLowerCase().startsWith("#f");
  const src = isLight ? "/belo-logo-white.png" : "/belo-logo.png";
  return (
    <img
      src={src}
      alt="BELO"
      style={{ height: `${px}px`, width: "auto", display: "block" }}
      className={className}
      draggable={false}
      {...rest}
    />
  );
};

export default BeloLogo;
